import * as React from 'react';
import formStyle from '../../core/forms/style/WForm.less';
import { lazyInject } from '../../services/inversify';
import { TriggerService } from '../../core/trigger/trigger_service';
import { ApiService } from '../../services/api_service';
import { IDs } from '../../helpers/IDs';
import { WActionButton } from '../../core/elements/WActionButton';
import DialogWrapper2 from '../../core/dialog/dialog_wrapper_v2';
import { WFormsTableWrapper } from '../../core/table/WFormsTableWrapper';
import { WHelpIcon } from '../../core/elements/WHelpIcon';
import { WSpinner } from '../../core/elements/spinner/WSpinner';

export interface DateneingabeBetrieblicheDatenWeitereGewerkeProps {
    data: any;
}

export interface DateneingabeBetrieblicheDatenWeitereGewerkeState {
    showDialog: boolean
    showSpinner: boolean;
    refreshStamp: number;
    customFormConfig: any;
    bundleFilterFunc: (bundle: any) => void;
}

export class DateneingabeBetrieblicheDatenWeitereGewerke extends React.Component<DateneingabeBetrieblicheDatenWeitereGewerkeProps, DateneingabeBetrieblicheDatenWeitereGewerkeState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showDialog: false,
            showSpinner: false,
            refreshStamp: 0,
            customFormConfig: null,
            bundleFilterFunc: null,
        };
        this.bereichKey = this.apiService.getBereichKey();
        this.validateField = this.validateField.bind(this);
    }

    @lazyInject(ApiService) private apiService: ApiService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private bereichKey: string;
    private bundle: any;

    componentDidMount(): void {
        this.updateSettings({});
    }

    render(): JSX.Element {
        return (
            <div>
                <div className={formStyle.fieldBox}>
                    <div className={formStyle.label} style={{ display: 'flex', justifyContent: 'unset' }}>
                        Weitere Gewerke
                        <WHelpIcon
                            data={this.props.data}
                            styleDivProps={{
                                marginTop: 6, marginLeft: 10
                            }}
                            styleProps={{
                                width: 16, height: 14, borderRadius: 10, backgroundColor: 'transparent', margin: 0
                            }}
                            label='Info "Weitere Gewerke"'
                            helpKey={`${IDs.MOD_ETOOL}_${IDs.ENT_WEITERE_GEWERKE}`}
                            type={'theme_info'}
                            style={'theme_small'}
                            customElement={'info'}
                            editBar={true}
                            useTheme={true}
                        />
                    </div>
                    <div className={formStyle.input} style={{ flexDirection: 'row' }}>
                        <div className={formStyle.listWrapper}>
                            {(this.props.data[IDs.ENT_WEITERE_GEWERKE] || []).map((r: any) => <div>{r.gewerk_tid}</div>)}
                        </div>
                        <div style={{ width: 'auto' }}>
                            <WActionButton
                                tooltip='Weitere Gewerke bearbeiten'
                                label='Weitere Gewerke bearbeiten'
                                action='theme_edit'
                                key='btn_edit_weitere_gewerke'
                                styleProps={{ marginRight: 2 }}
                                onAction={() => this.setState({ showDialog: true })}
                            />
                        </div>
                    </div>
                </div>
                {this.state.showDialog && this.renderDialog()}
                {this.state.showSpinner && <WSpinner />}
            </div >
        );
    }

    renderDialog(): JSX.Element {
        return (
            <DialogWrapper2
                title={'Weitere Gewerke bearbeiten'}
                width={-1}
                onAfterClose={() => {
                    this.setState({ showDialog: false, showSpinner: true }, () =>
                        this.triggerService.fire('reload', IDs.ENT_WEITERE_GEWERKE, () => this.setState({ showSpinner: false })));
                }}
            >
                <div style={{ width: 800 }}>
                    <WFormsTableWrapper
                        entity={IDs.ENT_WEITERE_GEWERKE}
                        module={IDs.MOD_ETOOL}
                        customClass={'Custom-ETA'}
                        formLayout={'flowV2'}
                        actions={['add', 'edit', 'delete']}
                        showColumnsHelp
                        tablePageSize={10}
                        validateField={this.validateField}
                        refreshStamp={this.state.refreshStamp}
                        customFormConfig={this.state.customFormConfig}
                        bundleFilterFunc={this.state.bundleFilterFunc}
                    />
                </div>
            </DialogWrapper2>
        );
    }

    validateField(key: string, value: any, WFormData: any, onValueChange: (name: string, value: any) => void): string {
        const formValues = WFormData.getAllValues();
        if (key === 'gewerk_tid') {
            this.updateSettings(formValues);
        }
        return '';
    }

    updateSettings(formValues: any) {
        const privat_flag: boolean = this.bereichKey === 'privat';
        const disableWZ = !formValues.gewerk_tid || formValues.gewerk_tid === 147 /* Kein Handwerk *//* || formValues.gewerk_tid === 148 *//* Handwerkskammer */ || privat_flag;
        const customFormConfig: any = {
            wz_tid: {
                hidden: disableWZ,
                required: !disableWZ
            }
        };
        if (this.bereichKey === 'sonstige') {
            customFormConfig.wz_tid.bundle_output = ['B:WZ 2008:', 'code_2008', 'bezeichnung_2008'];
        }

        const bundleFilterFunc = (bundle: any) => {
            if (!this.bundle) {
                // Wir speichern das ursprünliche Bundle.
                this.bundle = bundle;
            }
            const bundle2: any = {};
            bundle2.gewerk_tid = (this.bundle.gewerk_tid || []).filter((r: any) => r.bereich_key === this.bereichKey);
            bundle2.wz_tid = (this.bundle.wz_tid || []).filter((w: any) => w.gewerk_tid === formValues.gewerk_tid);
            // console.log(formValues.gewerk_tid, bundle2);
            return bundle2;
        };

        this.setState({ customFormConfig, bundleFilterFunc, refreshStamp: this.state.refreshStamp + 1 });
    }
}
